import CheckoutModal from "@/components/checkout/CheckoutModal";
import { getProduct } from "@/lib/products";

/**
 * Backwards-compatible wrapper used by the home purchase flow.
 * Prefer importing CheckoutModal directly for new call sites.
 */
const QuickRegister = ({
  isOpen,
  onClose,
  paymentType = "bank",
  purchaseType = "basic",
  profileId,
  onSuccess,
}) => (
  <CheckoutModal
    isOpen={isOpen}
    onClose={onClose}
    product={getProduct(purchaseType) || getProduct("basic")}
    paymentType={paymentType}
    profileId={profileId}
    onSuccess={onSuccess}
  />
);

export default QuickRegister;
